// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"74105081","482":"9150b84a","567":"01a5acbe","651":"57455c88","723":"ea3eb979"}[chunkId] + ".chunk.js";
};